import React from 'react';

import prizeCardAVIF from '../../../../../../../client/assets_seller/landingpages/june_prize_draw/prize-card.avif';
import prizeCardPNG from '../../../../../../../client/assets_seller/landingpages/june_prize_draw/prize-card.png';
import prizeCardWEBP from '../../../../../../../client/assets_seller/landingpages/june_prize_draw/prize-card.webp';

import Texts from './PrizeSection.texts.json';

import styles from './PrizeSection.module.scss';

export const PrizeSection: React.FC = () => (
  <div className={styles.component}>
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        <picture>
          <source srcSet={prizeCardAVIF} type="image/avif" />
          <source srcSet={prizeCardWEBP} type="image/webp" />
          <img alt="BMW 1 Series 120 M Sport prize car" src={prizeCardPNG} />
        </picture>
      </div>
      <div className={styles.content}>
        <h2 className={styles.title}>{Texts.title}</h2>
        <div className={styles.description}>
          {Texts.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    </div>
  </div>
);
